import { ReactElement } from 'react'
import AppBar from '@mui/material/AppBar'
import CssBaseline from '@mui/material/CssBaseline'
import Toolbar from '@mui/material/Toolbar'
import Paper from '@mui/material/Paper'
import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import { always, ifElse, equals } from 'ramda'

interface Props {
  children: ReactElement | ReactElement[]
  title: string
  requireAuth?: boolean
}

let useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    paperContainer: {
      margin: theme.spacing(3),
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    appBar: {
      borderBottom: '1px solid white',
      backgroundColor: theme.palette.background.default,
    },
  }),
)

let UnauthenticatedLayout = ({
  title,
  children,
  requireAuth = false,
}: Props): ReactElement => {
  let classes = useStyles()

  return (
    <>
      <CssBaseline />
      <AppBar color="inherit" position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      {ifElse(
        equals(false),
        // Explicitly set `requireAuth` to false to get the unauth page layout
        always(
          <Paper className={classes.paperContainer}>
            <main className={classes.content}>{children}</main>
          </Paper>,
        ),
        // Sign-in page will never have `requireAUth` explicitly set
        always(children),
      )(requireAuth)}
    </>
  )
}

export default UnauthenticatedLayout
